import React, { useState, useCallback } from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import { theme } from '../theme';
import { hasCoarsePointer } from '../utils/useIsNarrowWindow';
import { ChevronIcon } from './ChevronIcon';
/**
 * Small round chevron button (matches the native SF Symbols-style arrows)
 * with a hover effect; outlined with a grey chevron and disabled when you can't page further.
 * Used by MealMapHeaderTitle.web and SummaryHeaderTitle.web.
 */
export const NavArrowButton = ({ direction, disabled, onPress, }) => {
    const [hovered, setHovered] = useState(false);
    const onMouseEnter = useCallback(() => {
        if (!disabled) {
            setHovered(true);
        }
    }, [disabled]);
    const onMouseLeave = useCallback(() => {
        setHovered(false);
    }, []);
    const buttonStyle = [
        styles.button,
        ...(disabled ? [styles.buttonDisabled] : []),
        ...(!disabled && hovered ? [styles.buttonHovered] : []),
    ];
    // Touch screens: keep the small chip look but grow the tap area to 44×44.
    const coarse = hasCoarsePointer();
    const icon = (<ChevronIcon direction={direction} size={12} color={disabled ? FG_DISABLED : FG_DEFAULT}/>);
    return (<View onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <TouchableOpacity disabled={disabled} onPress={onPress} activeOpacity={0.7} accessibilityRole="button" accessibilityLabel={direction === 'back' ? 'Previous' : 'Next'} accessibilityState={{ disabled }} testID={`nav-arrow-${direction}`} style={coarse ? styles.touchTarget : buttonStyle}>
        {coarse ? (<View style={buttonStyle}>{icon}</View>) : (<View style={styles.inner}>{icon}</View>)}
      </TouchableOpacity>
    </View>);
};
const CHIP_SIZE = 28; // round button
const BG_DEFAULT = theme.colors.navArrowBackground;
const BG_HOVER = theme.colors.navArrowBackgroundHover;
const BG_DISABLED = theme.colors.navArrowBackgroundDisabled;
const FG_DEFAULT = theme.colors.navArrowForeground;
const FG_DISABLED = theme.colors.navArrowForegroundDisabled;
const MIN_TAP_SIZE = 44;
const styles = StyleSheet.create({
    touchTarget: {
        minWidth: MIN_TAP_SIZE,
        minHeight: MIN_TAP_SIZE,
        alignItems: 'center',
        justifyContent: 'center',
    },
    button: {
        width: CHIP_SIZE,
        height: CHIP_SIZE,
        borderRadius: CHIP_SIZE / 2,
        backgroundColor: BG_DEFAULT,
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
    },
    buttonDisabled: {
        backgroundColor: BG_DISABLED,
        cursor: 'auto',
    },
    buttonHovered: {
        backgroundColor: BG_HOVER,
    },
    inner: {
        alignItems: 'center',
        justifyContent: 'center',
    },
});
